<template>
  <v-footer id="dashboard-core-footer">
    <v-container class="pb-0">
      <v-row align="center" justify="center" no-gutters>
        <v-col v-for="(link, i) in links" :key="i" class="text-center mb-sm-0 mb-5" cols="auto">
          <a
            :href="link.href"
            class="mr-0"
            :class="{
              'grey--text text--darken-3': !$vuetify.theme.dark,
              'dark_Textgrey--text': $vuetify.theme.dark,
            }"
            rel="noopener"
            target="_blank"
            v-text="link.text"
          />
        </v-col>
      </v-row>

      <v-row
        justify="center"
        class="version mt-3"
        :class="{
          'grey--text text--darken-3': !$vuetify.theme.dark,
          'dark_Textgrey--text': $vuetify.theme.dark,
        }"
      >
        v{{ version }}
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'DashboardCoreFooter',
  data: () => ({
    version: process.env.VUE_APP_VERSION,
  }),
  computed: {
    links() {
      return [
        {
          href: 'https://www.filios.app/tutoriales/',
          text: this.$t('appBar.title.tutorial'),
        },
        {
          href: 'https://www.filios.app/guia-de-fiscalidad/',
          text: this.$t('appBar.title.taxGuide'),
        },
        {
          href: 'https://www.filios.app/contacta',
          text: this.$t('footer.contact'),
        },
        {
          href: 'https://www.filios.app/contacta',
          text: this.$t('footer.giveFeedback'),
        },
        {
          href: 'https://www.filios.app/aviso-legal-terminos-y-condiciones',
          text: 'Legal',
        },
      ]
    },
  },
}
</script>

<style lang="scss">
#dashboard-core-footer {
  background-color: #f7f8fb;
  &.theme--dark {
    background-color: #292929;
  }
  a {
    font-weight: 500;
    text-decoration: none;
    text-transform: none;
  }
  a:hover {
    color: #2597fe !important;
  }

  .version {
    font-size: 10px;
  }
}
</style>
